
























































































































































































































































































































































































































































































































import Vue from 'vue'
import { throttle } from 'lodash'
import mixins from 'vue-typed-mixins'

import UserManagementMixin from './UserManagementMixin'
import Privacy from '@/components/Privacy.vue'
import ConditionsForParticipation from '@/components/ConditionsForParticipation.vue'

import { types, params } from '@/components/registration/module/types'
import { AxiosInstance, AxiosPromise, AxiosResponse } from 'axios'

export default mixins(UserManagementMixin).extend({
  components: {
    Privacy,
    ConditionsForParticipation,
  },
  computed: {
    registrationErrors(): object {
      return this.$store.getters
    },
    termsAccepted(): boolean {
      return (
        !this.usernameEmpty &&
        !this.passwordEmpty &&
        !this.passwordConfirmEmpty &&
        !this.emailEmpty &&
        !this.phoneNoEmpty &&
        !this.phoneNoInvalid &&
        !this.emailNotReadyForNewTreatment &&
        !this.emailInvalid &&
        !this.emailTaken &&
        this.signUpForm &&
        this.signUpForm.confirm_trial_information &&
        this.signUpForm.confirm_privacy_statement &&
        this.signUpForm.confirm_voluntary_participation &&
        this.signUpForm.confirm_optional_surveys &&
        this.signUpForm.confirm_diverse_options &&
        this.signUpForm.confirm_personal_email &&
        this.signUpForm.confirm_legal_age &&
        this.signUpForm.confirm_no_other_concurrent_treatment &&
        this.signUpForm.confirm_no_financial_compensation &&
        this.signUpForm.confirm_contact_via_phone_and_email &&
        this.signUpForm.confirm_processing_of_information
      )
    },
    phoneNoEmpty(): boolean {
      return this.signUpForm.phone == null || this.signUpForm.phone.length == 0
    },
    phoneNoInvalid(): boolean {
      const re1 = new RegExp('^\\+[0-9]{2,4}[0-9,-,\\s]{7,}')
      const re2 = new RegExp('^0[0-9,-,\\s]{7,}')
      return (
        this.signUpForm.phone != null &&
        this.signUpForm.phone.length > 0 &&
        !re1.test(this.signUpForm.phone) &&
        !re2.test(this.signUpForm.phone)
      )
    },
    usernameEmpty(): boolean {
      return this.signUpForm.username == null || this.signUpForm.username.length == 0
    },
    passwordEmpty(): boolean {
      return this.signUpForm.password == null || this.signUpForm.password.length == 0
    },
    passwordConfirmEmpty(): boolean {
      return (
        this.signUpForm.password_confirmation == null ||
        this.signUpForm.password_confirmation.length == 0
      )
    },
    emailEmpty(): boolean {
      return this.signUpForm.email == null || this.signUpForm.email.length == 0
    },
  },
  data: () => ({
    signUpForm: {
      username: '',
      email: '',
      password: '',
      phone: '',
      password_confirmation: '',
      is_patient_account: true,
      accesspath_kind: '',
      accesspath_detail: '',
      confirm_trial_information: false,
      confirm_privacy_statement: false,
      confirm_voluntary_participation: false,
      confirm_optional_surveys: false,
      confirm_diverse_options: false,
      confirm_personal_email: false,
      confirm_legal_age: false,
      confirm_no_other_concurrent_treatment: false,
      confirm_no_financial_compensation: false,
      confirm_contact_via_phone_and_email: false,
      confirm_processing_of_information: false,
      language: 'ar',
    },
  }),
  methods: {
    signUp() {
      //locale noch setzen!!
      this.signUpForm.language = this.$i18n.locale
      this.validate()
        .then(valid => {
          if (valid) {
            return this.$store.dispatch({
              profile: this.signUpForm,
              type: types.actions.Register,
            })
          } else {
            throw new Error('validation contains errors')
          }
        })
        .then(() => {
          this.$router.replace({ name: 'login', params: { registration: 'ok' } })
        })
    },
    validate(): Promise<boolean> {
      const http: AxiosInstance = this.$store.getters.http
      let that = this

      //aktuell wird die Telefonnummern-Prüfung über die termsAccepted abgebildet!!!
      //erst mal schauen, ob die Telefonnummer gültig ist. Wenn nicht, dann kann gleich false zurück geliefert werden
      /*if (this.phoneNoEmpty || this.phoneNoInvalid) {
        return new Promise((resolve, reject) => {
          resolve(false)
        })
      }*/

      return http.post('/api/auth/users/validate', { user: this.signUpForm }).then(response => {
        this.validation = response.data
        return !!response.data.ok
      })
    },
    throttledValidate: throttle(
      function() {
        return (this as any).validate()
      },
      500,
      { leading: false }
    ),
  },
  watch: {
    'signUpForm.username': function(oldValue: string, newValue: string) {
      this.throttledValidate()
    },
    'signUpForm.email': function(oldValue: string, newValue: string) {
      this.throttledValidate()
    },
    'signUpForm.password': function(oldValue: string, newValue: string) {
      this.throttledValidate()
    },
    'signUpForm.password_confirmation': function(oldValue: string, newValue: string) {
      this.throttledValidate()
    },
  },
})
